export const T = {
  en_GB: { backToPortfolios: "Back to all portfolios" },
  nb_NO: { backToPortfolios: "Tilbake til alle porteføljer" },
} as const;
